import {
  Box,
  Center,
  Flex,
  HStack,
  Image,
  Link,
  VStack,
} from '@chakra-ui/react';
import { ReactNode, useMemo } from 'react';
import { useIntl } from 'react-intl';
import IconCheckBlur from '../../../../images/icons/icon-check-blur.svg';
import IconCheckGreen from '../../../../images/icons/icon-check-green.svg';
import IconNotIncluded from '../../../../images/icons/icon-not-included.svg';
// import { ReactComponent as Check } from '../../../../images/icons/icon-check.svg';
import minimumFractionDigits from '../../../../components/CommonFunction/minimumFractionDigits';
import MyDeviceFS from '../../../../images/device-fs.jpg';
import MyDeviceSTMax from '../../../../images/device-st-max.jpg';
import MyDeviceSTPlus from '../../../../images/device-st-plus.jpg';
import MyDeviceST from '../../../../images/device-st.jpg';
import { ReactComponent as CheckMemberships } from '../../../../images/icons/icon-check-feature-memberships.svg';
import { ReactComponent as CreditCardCheck } from '../../../../images/icons/icon-credit-card-check.svg';
import { ReactComponent as Info } from '../../../../images/icons/icon-info-optimotion.svg';
import { ReactComponent as Perks } from '../../../../images/icons/icon-star-solid-perks.svg';
import { ProductInterface } from '../../../../models/shop';
import {
  DataDeviceSkyTrak,
  DataMembershipSkyTrak,
  ItemProductPurchaseHistory,
  MembershipSkyTrak,
  RenewMembershipsExpire,
} from '../../../../models/skytrak';
import { ConfigurationPublicData } from '../../../../slices/loadConfiguration';
import { UserData } from '../../../../models/user';
import _ from 'lodash';

export const srcSquare = window.location.hostname.match(
  /clubhouse.skytrakgolf.com|clubhouse.skytrakgolf.jp/
)
  ? 'https://web.squarecdn.com/v1/square.js'
  : 'https://sandbox.web.squarecdn.com/v1/square.js';

export const authDataSquare = {
  appId: window.location.hostname.match(
    /clubhouse.skytrakgolf.com|clubhouse.skytrakgolf.jp/
  )
    ? 'sq0idp-A376kNX6jn85IrPOY6W1Gw'
    : 'sandbox-sq0idb-P6Lm-Aiuj8iWabeNZUMOCg',
  locationID: window.location.hostname.match(
    /clubhouse.skytrakgolf.com|clubhouse.skytrakgolf.jp/
  )
    ? 'LB00RH9GE0Q0C'
    : // : window.location.hostname.match(/clubhouseqa.skytrakgolf.com/)
      'L4CFWYT9QVX1C',
  // : 'LPBNE8APKDAVN',
};

export const darkModeCardStyle = {
  '.input-container': {
    borderColor: '#55BB2C',
    borderRadius: '16px',
    borderWidth: '4px',
  },
  '.input-container.is-focus': {
    borderColor: '#55BB2C',
    borderWidth: '4px',
  },
  '.input-container.is-error': {
    borderColor: '#ff1600',
    borderWidth: '4px',
  },
  '.message-text': {
    color: '#8a8a8D',
  },
  '.message-icon': {
    color: '#8a8a8D',
  },
  '.message-text.is-error': {
    color: '#ff1600',
  },
  '.message-icon.is-error': {
    color: '#ff1600',
  },
  input: {
    backgroundColor: '#FFF',
    color: '#36383E',
    fontSize: '16px',
  },
  'input::placeholder': {
    color: '#8a8a8D',
  },
  'input.is-error': {
    color: '#ff1600',
  },
};

type ItemReturnDuration = {
  item: DataMembershipSkyTrak;
};

export const ReturnDuration = ({ item }: ItemReturnDuration) => {
  const intl = useIntl();
  if (item.frequencyUnit === 'year') {
    return (
      <Box>
        {intl.formatMessage(
          { id: 'Year' },
          {
            years: item.frequencyCount,
          }
        )}
      </Box>
    );
  }
  if (item.frequencyUnit === 'month') {
    return (
      <Box>
        {intl.formatMessage(
          { id: 'Month' },
          {
            months: item.frequencyCount,
          }
        )}
      </Box>
    );
  }
  if (item.frequencyUnit === 'week') {
    return (
      <Box>
        {intl.formatMessage(
          { id: 'Week' },
          {
            weeks: item.frequencyCount,
          }
        )}
      </Box>
    );
  }

  if (item.frequencyUnit === 'day') {
    return (
      <Box>
        {intl.formatMessage(
          { id: 'Day' },
          {
            days: item.frequencyCount,
          }
        )}
      </Box>
    );
  }
  return <Box></Box>;
};

export const FeatureBasic = () => {
  const intl = useIntl();

  const arrayOptionsPlan = [
    'Drivingrange',
    'SwingLab',
    'Connect3rdParty',
    'CoursePlay',
    'UnlockAddonFeature',
  ];

  return (
    <VStack spacing={'12px'} width={'100%'} alignItems={'flex-start'}>
      {arrayOptionsPlan.map(
        (title: string, idx: number) =>
          idx < 4 && (
            <HStack key={idx} gap={'8px'} alignItems={'flex-start'}>
              <Center minWidth={{ mobile: '24px' }}>
                {idx === 0 ? (
                  <Image src={IconCheckGreen} />
                ) : (
                  <Image src={IconCheckBlur} />
                )}
              </Center>
              <Box
                fontWeight={600}
                fontSize={14}
                lineHeight={{ mobile: '20px' }}
                pt={'2px'}
              >
                {intl.formatMessage({ id: title })}
              </Box>
            </HStack>
          )
      )}
    </VStack>
  );
};

export const FeatureEssentialTrial = () => {
  const intl = useIntl();

  const arrayOptionsPlan = [
    'ImprovementRanges',
    'GameImprovement',
    'Connect3rdParty',
    'CoursePlayFeatureInEssential',
    'UnlockAddonFeature',
  ];

  return (
    <VStack spacing={'12px'} width={'100%'} alignItems={'flex-start'}>
      {arrayOptionsPlan.map((title: string, idx: number) => (
        <HStack key={idx} spacing={'8px'} alignItems={'flex-start'}>
          <Center minWidth={{ mobile: '24px' }}>
            {idx < 4 ? (
              <Image src={IconCheckGreen} />
            ) : (
              <Image src={IconCheckBlur} />
            )}
          </Center>
          <Box
            fontWeight={600}
            fontSize={14}
            lineHeight={{ mobile: '20px' }}
            pt={'2px'}
          >
            {title === 'CoursePlayFeatureInEssential'
              ? intl.formatMessage(
                  { id: title },
                  {
                    i: (chunks: ReactNode) => (
                      <span
                        style={{
                          marginLeft: '4px',
                          fontStyle: 'italic',
                          fontWeight: 400,
                        }}
                      >
                        {chunks}
                      </span>
                    ),
                  }
                )
              : intl.formatMessage({ id: title })}
          </Box>
        </HStack>
      ))}
    </VStack>
  );
};

export const FeatureEssential = () => {
  const intl = useIntl();

  const arrayOptionsPlan = [
    'ImprovementRanges',
    'GameImprovement',
    'Connect3rdParty',
    'CoursePlayFeatureInEssential',
    'UnlockAddonFeature',
  ];

  return (
    <VStack spacing={'12px'} width={'100%'} alignItems={'flex-start'}>
      {arrayOptionsPlan.map((title: string, idx: number) => (
        <HStack key={idx} spacing={'8px'} alignItems={'flex-start'}>
          <Center minWidth={{ mobile: '24px' }}>
            <Image src={IconCheckGreen} />
          </Center>
          <Flex
            fontWeight={600}
            fontSize={14}
            lineHeight={{ mobile: '20px' }}
            pt={{ mobile: '2px' }}
            display={'inline'}
          >
            <Box display={'inline'} mr={'6px'}>
              {title === 'CoursePlayFeatureInEssential'
                ? intl.formatMessage(
                    { id: title },
                    {
                      i: (chunks: ReactNode) => (
                        <span
                          style={{
                            marginLeft: '4px',
                            fontStyle: 'italic',
                            fontWeight: 400,
                          }}
                        >
                          {chunks}
                        </span>
                      ),
                    }
                  )
                : intl.formatMessage({ id: title })}
            </Box>
            {/* {title === 'CoursePlay' && (
              <Box
                display={'inline-flex'}
                fontStyle={'italic'}
                fontWeight={400}
              >
                {intl.formatMessage({ id: 'CoursePlayFeature' })}
              </Box>
            )} */}
          </Flex>
        </HStack>
      ))}
    </VStack>
  );
};

export const FeatureFSCourse = () => {
  const intl = useIntl();

  const arrayCoursePlayOptions = [
    'FSCoursePlayFeature1',
    'FSCoursePlayFeature2',
    'FSCoursePlayFeature3',
    'FSCoursePlayFeature4',
  ];

  return (
    <VStack spacing={'12px'} width={'100%'} alignItems={'flex-start'}>
      {arrayCoursePlayOptions.map((title: string, idx: number) => (
        <HStack key={idx} spacing={'8px'} alignItems={'flex-start'}>
          <Center minWidth={{ mobile: '24px' }}>
            <Image src={IconCheckGreen} />
          </Center>
          <Box
            fontWeight={600}
            fontSize={14}
            lineHeight={{ mobile: '20px' }}
            pt={'2px'}
          >
            {intl.formatMessage({ id: title })}
          </Box>
        </HStack>
      ))}
    </VStack>
  );
};

export const FeatureCourse = () => {
  const intl = useIntl();

  const arrayCoursePlayOptions = [
    'CoursePlayFeature1',
    'QuailHollowClub',
    'SweetensCoveGolfClub',
    'CoursePlayFeature4',
  ];

  return (
    <VStack spacing={'12px'} width={'100%'} alignItems={'flex-start'}>
      {arrayCoursePlayOptions.map((title: string, idx: number) => (
        <HStack key={idx} spacing={'8px'} alignItems={'flex-start'}>
          <Center minWidth={{ mobile: '24px' }}>
            <Image src={IconCheckGreen} />
          </Center>
          <Box
            fontWeight={600}
            fontSize={14}
            lineHeight={{ mobile: '20px' }}
            pt={'2px'}
          >
            {intl.formatMessage({ id: title })}
          </Box>
        </HStack>
      ))}
    </VStack>
  );
};

export const FeatureWGT = () => {
  const intl = useIntl();

  const arrayWGTOptions = ['WGTFeature1', 'WGTFeature2'];

  return (
    <VStack spacing={'12px'} width={'100%'} alignItems={'flex-start'}>
      {arrayWGTOptions.map((title: string, idx: number) => (
        <HStack key={idx} spacing={'8px'} alignItems={'flex-start'}>
          <Center minWidth={{ mobile: '24px' }}>
            {idx === 3 ? (
              <Image src={IconCheckBlur} />
            ) : (
              <Image src={IconCheckGreen} />
            )}
          </Center>
          <Box
            fontWeight={600}
            fontSize={14}
            lineHeight={{ mobile: '20px' }}
            pt={'2px'}
          >
            {intl.formatMessage({ id: title })}
          </Box>
        </HStack>
      ))}
    </VStack>
  );
};

type ReturnNameBySkuProps = {
  item: DataMembershipSkyTrak;
};

type ReturnNameBySkuPurchaseHistoryProps = {
  item: ItemProductPurchaseHistory;
};

// type ReturnNameByNameProps = {
//   item: DataDeviceSkyTrak;
// };

export const SKU_UPGRADE =
  /Upgrade PIP PP|Upgrade-Old-GIP-to-New-PIP|Upgrade-PIP-1505|Upgrade to Play and Improve Package/;
export const SKU_COURSEPLAY = /Course Play|CP-STD/;
export const SKU_FS_COURSEPLAY = /CP-FS-365/;
export const SKU_PIP = /PLAY-IMPROVE|GipPlay|GIP-Play|GIP-PLAY|PLAY IMPROVE/;
export const SKU_GIP =
  /GameImp|GameImprove|GAMEIMPROVE|Game Improvement|Game-Improvement|MEM-ESS-365/;
export const SKU_ESSENTIAL_NEW_UPPER = /MEM-ESS-365/;
export const SKU_CORE_UPPER = /MEM-COR-365/;
export const SKU_ELITE_UPPER = /MEM-ELT-365/;
export const SKU_CORE_TRACKMAN_UPPER = /CORE-TRACMAN|MEM-COR-TM-365|CORE-TM/;
export const SKU_ADD_TO_CART =
  /MEM-ESS-365|MEM-COR-365|MEM-ELT-365|MEM-COR-TM-365/;
export const SKU_SHOW_COMPATIBLE = /MEM-COR-365|MEM-COR-TM-365|MEM-ELT-365/;
export const SKU_REQUEST_PROMO_CODE =
  /^(GIP|MEM-ESS-365|MEM-COR-365|MEM-COR-TM-365|MEM-ELT-365|ELITE-TRIAL)$/;
export const EXACT_SKU_RENEW_PATTERN =
  /^(UPGRADE_OLD_GIP_TO_NEW_PIP|UPGRADE_NEW_GIP_TO_NEW_PIP|UPGRADE_OLD_PIP_TO_NEW_PIP|GIP|PIP|GAME-IMPROVEMENT|MEM-ESS-365|MEM-COR-365|MEM-ELT-365|MEM-COR-TM-365|CORE-TM)$/;
export const SKU_WARRANTY_ADD_TO_CART =
  /^(ST-SKYTRAK-SKYCARE-3|ST-SKYTRAK-SKYCARE-2YR|SKYCARE-1YR-STOG-STP|SKYCARE-2YR-STOG-STP)$/;
export const MEMBERSHIP_PARAMS = /^(essential|core-plus|core|elite)$/;
export const CALCULATE_MEMBERSHIP_REMAIN = [
  'MEM-ESS-365',
  'MEM-COR-365',
  'MEM-COR-TM-365',
  'MEM-ELT-365',
];

export const CALCULATE_MEMBERSHIP_REMAIN_FROM_ESS = [
  'MEM-COR-365',
  'MEM-COR-TM-365',
  'MEM-ELT-365',
];

export const CALCULATE_MEMBERSHIP_REMAIN_FROM_CORE = [
  'MEM-COR-TM-365',
  'MEM-ELT-365',
];

export const SKU_ELITE_TRIAL = /ELITE-TRIAL/;

const getFormattedMembershipName = ({
  name,
  sku,
  referenceLegacyId,
  intl,
}: {
  name?: string;
  sku?: string;
  referenceLegacyId?: any;
  intl: any;
}) => {
  const nameLower = name?.toLowerCase() || '';
  const skuUpper = sku?.toUpperCase() || '';

  if (nameLower.match(/basic/)) return intl.formatMessage({ id: 'Basic' });
  if (nameLower.match(/trial/) && !nameLower.match(/elite/))
    return intl.formatMessage({ id: 'CoreTrial' });
  if (name?.match(/Essential/) && name?.match(/E6 Software Pack/))
    return intl.formatMessage({ id: 'EssentialPlusE6' });
  if (sku?.match(SKU_GIP) || (sku && sku === 'GIP') || name?.match(SKU_GIP))
    return intl.formatMessage({ id: 'Essential' });
  if (sku?.match(SKU_COURSEPLAY))
    return intl.formatMessage({ id: 'CoursePlayStandard' });
  // if (name?.match(/E6WGTSoftwarePack/) && !referenceLegacyId)
  //   return intl.formatMessage({ id: 'EssentialPlusE6' });

  if (sku?.match(SKU_PIP) || sku === 'PIP' || name?.match(SKU_PIP)) {
    return intl.formatMessage({ id: 'EssentialPlusE6' });
  }

  if (
    sku?.match(SKU_UPGRADE) ||
    sku?.toUpperCase().match(/E6 NEW PIP|E6WGTSOFTWAREPACK/) ||
    name?.match(/E6WGTSoftwarePack/)
  ) {
    return intl.formatMessage({ id: 'E6New' });
  }
  if (skuUpper.match(SKU_ELITE_UPPER))
    return intl.formatMessage({ id: 'Elite' });
  if (skuUpper.match(SKU_ESSENTIAL_NEW_UPPER))
    return intl.formatMessage({ id: 'Essential' });
  if (skuUpper.match(SKU_CORE_TRACKMAN_UPPER))
    return intl.formatMessage({ id: 'CorePlus' });
  if (skuUpper.match(SKU_CORE_UPPER)) return intl.formatMessage({ id: 'Core' });
  if (skuUpper.match(SKU_ELITE_TRIAL))
    return intl.formatMessage({ id: 'EliteTrial' });

  if (nameLower.match(/core/)) {
    if (nameLower.match(/trackman|plus/)) {
      return intl.formatMessage({ id: 'CorePlus' });
    }
    return intl.formatMessage({ id: 'Core' });
  }

  return intl.formatMessage({
    id: name?.replace(/\s/g, '') || sku?.replace(/\s/g, '') || '',
    defaultMessage: name || sku || '',
  });
};

export const ReturnNameBySku = ({ item }: ReturnNameBySkuProps) => {
  const intl = useIntl();
  const returnName = useMemo(
    () =>
      getFormattedMembershipName({
        name: item.membershipTypeName,
        sku: item.sku,
        referenceLegacyId: item.referenceLegacyId,
        intl,
      }),
    [intl, item]
  );
  return <Box display="inline">{returnName}</Box>;
};

export const ReturnNameBySkuCard = ({ sku }: { sku: string }) => {
  const intl = useIntl();
  const returnName = useMemo(
    () =>
      getFormattedMembershipName({
        name: '',
        sku: sku,
        intl,
      }),
    [intl, sku]
  );
  return <Box display="inline">{returnName}</Box>;
};

export const ReturnProductNameBySku = ({
  product,
}: {
  product: ProductInterface;
}) => {
  const intl = useIntl();
  const returnName = useMemo(
    () =>
      getFormattedMembershipName({
        name: product.name || '',
        sku: product.sku || '',
        intl,
      }),
    [intl, product]
  );
  return <Box display="inline">{returnName}</Box>;
};

export const ReturnNameBySkuPurchaseHistory = ({
  item,
}: ReturnNameBySkuPurchaseHistoryProps) => {
  const intl = useIntl();
  const returnName = useMemo(
    () =>
      getFormattedMembershipName({
        name: item.name,
        sku: item.sku,
        referenceLegacyId: null,
        intl,
      }),
    [intl, item]
  );
  return <Box display="inline">{returnName}</Box>;
};

export const ReturnNameByName = ({ item }: { item: DataDeviceSkyTrak }) => {
  const intl = useIntl();
  const returnName = useMemo(
    () =>
      getFormattedMembershipName({
        name: item.membershipTypeName,
        sku: item.membershipTypeName, // dùng chung logic SKU nếu có pattern match
        intl,
      }),
    [intl, item.membershipTypeName]
  );
  return <Box display="inline">{returnName}</Box>;
};

export const ReturnNameByNameCard = ({ name }: { name: string }) => {
  const intl = useIntl();
  const returnName = useMemo(
    () =>
      getFormattedMembershipName({
        name: name,
        sku: name, // dùng chung logic SKU nếu có pattern match
        intl,
      }),
    [intl, name]
  );
  return <Box display="inline">{returnName}</Box>;
};

export interface Mode {
  name: 'Basic' | 'Trial' | 'Essential' | 'Core' | 'CorePlus' | 'Elite';
  lv: number;
}

export const checkMode = (
  dataMembershipSkyTrak: MembershipSkyTrak | null,
  deviceEsn: DataDeviceSkyTrak[] | null
): Mode => {
  if (
    dataMembershipSkyTrak &&
    dataMembershipSkyTrak.currentMemberships &&
    dataMembershipSkyTrak.currentMemberships.length > 0
  ) {
    const checkMembershipCanUse =
      dataMembershipSkyTrak.currentMemberships.filter(
        (item) =>
          new Date(convertTimeUTCToLocal(item.expireDate)) > new Date() &&
          item.membershipTypeName &&
          ['skytrak', 'legacy'].includes(item.source) &&
          !['Upgraded', 'Refund'].includes(item.state)
      );
    if (checkMembershipCanUse && checkMembershipCanUse.length > 0) {
      const getLevel = (names: string[]): Mode => {
        const lower = names.map((n) => n.toLowerCase());
        if (lower.some((n) => /elite/.test(n) && !/trial/.test(n)))
          return { name: 'Elite', lv: 4 };
        if (lower.some((n) => /core/.test(n) && /plus|trackman/.test(n)))
          return { name: 'CorePlus', lv: 3 };
        if (lower.some((n) => /core/.test(n) && !/trial/.test(n)))
          return { name: 'Core', lv: 2 };
        if (lower.some((n) => /essential/.test(n) || /elite trial/.test(n)))
          return { name: 'Essential', lv: 1 };
        if (lower.some((n) => /trial/.test(n))) return { name: 'Trial', lv: 0 };
        if (lower.some((n) => /basic/.test(n))) return { name: 'Basic', lv: 0 };
        return { name: 'Basic', lv: 0 };
      };

      const result =
        checkMembershipCanUse.length > 0
          ? getLevel(checkMembershipCanUse.map((m) => m.membershipTypeName))
          : getLevel(deviceEsn?.map((d) => d.membershipTypeName) || []);

      return result;

      // if (
      //   checkMembershipCanUse.find((i) =>
      //     i.membershipTypeName.toLowerCase().match(/elite/i)
      //   )
      // ) {
      //   return { name: 'Elite', lv: 3 };
      // } else if (
      //   checkMembershipCanUse.find(
      //     (i) =>
      //       i.membershipTypeName.toLowerCase().match(/core/i) &&
      //       !i.membershipTypeName.toLowerCase().match(/trial/i)
      //   )
      // ) {
      //   return { name: 'Core', lv: 2 };
      // } else if (
      //   checkMembershipCanUse.find((i) =>
      //     i.membershipTypeName.toLowerCase().match(/essential/i)
      //   )
      // ) {
      //   return { name: 'Essential', lv: 1 };
      // } else if (
      //   checkMembershipCanUse.find((i) =>
      //     i.membershipTypeName.toLowerCase().match(/trial/i)
      //   )
      // ) {
      //   return { name: 'Trial', lv: 0 };
      // } else if (
      //   checkMembershipCanUse.find((i) =>
      //     i.membershipTypeName.toLowerCase().match(/basic/i)
      //   )
      // ) {
      //   return { name: 'Basic', lv: 0 };
      // }
    }
  }
  if (deviceEsn && deviceEsn.length > 0) {
    const check = deviceEsn.find((device) =>
      device.membershipTypeName.toLowerCase().match(/trial/)
    );
    if (check) {
      return check.membershipTypeName.toLowerCase().match(/elite/)
        ? { name: 'Essential', lv: 1 }
        : { name: 'Trial', lv: 0 };
    }
  }
  return { name: 'Basic', lv: 0 };
};

export const checkMembershipMode = (
  membershipSkyTrakName: string,
  oldMembershipSku: string = ''
): Mode => {
  if (
    membershipSkyTrakName.toLowerCase().match(/elite/i) &&
    !membershipSkyTrakName.toLowerCase().match(/trial/i)
  ) {
    return { name: 'Elite', lv: 4 };
  } else if (
    (membershipSkyTrakName.toLowerCase().match(/core/i) &&
      membershipSkyTrakName.toLowerCase().match(/plus|trackman/i)) ||
    oldMembershipSku?.toUpperCase()?.match(SKU_CORE_TRACKMAN_UPPER)
  ) {
    return { name: 'CorePlus', lv: 3 };
  } else if (
    (membershipSkyTrakName.toLowerCase().match(/core/i) &&
      !membershipSkyTrakName.toLowerCase().match(/trial/i)) ||
    oldMembershipSku?.toUpperCase()?.match(SKU_CORE_UPPER)
  ) {
    return { name: 'Core', lv: 2 };
  } else if (
    membershipSkyTrakName.toLowerCase().match(/essential/i) ||
    membershipSkyTrakName.toLowerCase().match(/elite trial/i) ||
    oldMembershipSku?.toUpperCase()?.match(SKU_ESSENTIAL_NEW_UPPER)
  ) {
    return { name: 'Essential', lv: 1 };
  }
  return { name: 'Basic', lv: 0 };
};

export const filterMembershipFunc = (
  dataMembershipSkyTrak: MembershipSkyTrak | null,
  idMembershipRenewed: number,
  idMembershipUpgraded: number
) => {
  if (
    dataMembershipSkyTrak &&
    dataMembershipSkyTrak.currentMemberships &&
    dataMembershipSkyTrak.currentMemberships.length > 0
  ) {
    return dataMembershipSkyTrak.currentMemberships.filter(
      (item) =>
        ((item.sku &&
          !item.sku?.toLowerCase().match(/st-basic|st basic|trial/i) &&
          item.sku?.toLowerCase() !== 'basic') ||
          !item.sku) &&
        new Date(convertTimeUTCToLocal(item.expireDate)) > new Date() &&
        ['legacy', 'skytrak'].includes(item.source) &&
        !['Upgraded', 'Refund'].includes(item.state) &&
        item.id !== idMembershipRenewed &&
        item.id !== idMembershipUpgraded
    );
  }
  return [];
};

export const checkProductSkytrakExpire = (
  item: DataMembershipSkyTrak,
  dataProductSkytrak?: ProductInterface[] | null
): RenewMembershipsExpire => {
  const defaults = {
    visiblePriorExp: 0,
    discountPriorExp: 0,
    discountPastExp: 0,
    visiblePastExp: 0,
    renewalDiscount: 0,
  };

  if (
    item.isSubscription &&
    (item.autoRenewStatus.match(/active/) || item.isAutoRenew)
  ) {
    return defaults;
  }

  const findProduct = dataProductSkytrak?.find((p) =>
    p?.sku
      ?.toUpperCase()
      .match(
        item?.sku === 'GIP' ? SKU_ESSENTIAL_NEW_UPPER : item?.sku?.toUpperCase()
      )
  );

  return findProduct
    ? {
        visiblePriorExp: findProduct.days_visible_prior_to_expiration ?? 0,
        discountPriorExp: findProduct.days_on_discount_prior_to_expiration ?? 0,
        discountPastExp: findProduct.days_on_discount_past_expiration ?? 0,
        visiblePastExp: findProduct.days_visible_past_to_expiration ?? 0,
        renewalDiscount: findProduct.renewal_discount_percent ?? 0,
      }
    : defaults;
};

export const filterMembershipSkyTrakNewFunc = (
  dataMembershipSkyTrak: MembershipSkyTrak | null,
  idMembershipRenewed: number,
  idMembershipUpgraded: number,
  dataProductSkytrak?: ProductInterface[] | null
) => {
  if (
    dataMembershipSkyTrak &&
    dataMembershipSkyTrak.currentMemberships &&
    dataMembershipSkyTrak.currentMemberships.length > 0
  ) {
    return dataMembershipSkyTrak.currentMemberships.filter((item) => {
      return (
        ((((item.sku &&
          (!item.sku?.toLowerCase().match(/st-basic|st basic|trial/i) ||
            item.sku?.toLowerCase().match(/elite-trial/i)) &&
          item.sku?.toLowerCase() !== 'basic') ||
          !item.sku) &&
          new Date(
            new Date(
              new Date(convertTimeUTCToLocal(item.expireDate))
            ).getTime() +
              checkProductSkytrakExpire(item, dataProductSkytrak)
                .visiblePastExp *
                24 *
                60 *
                60 *
                1000
          ) > new Date()) ||
          item.esn) &&
        ['legacy', 'skytrak'].includes(item.source) &&
        !['Upgraded', 'Refund'].includes(item.state) &&
        item.id !== idMembershipRenewed &&
        item.id !== idMembershipUpgraded
      );
    });
  }
  return [];
};

export const filterAddOnsFunc = (
  dataMembershipSkyTrak: MembershipSkyTrak | null,
  idMembershipRenewed: number,
  idMembershipUpgraded: number
) => {
  if (
    dataMembershipSkyTrak &&
    dataMembershipSkyTrak.currentMemberships &&
    dataMembershipSkyTrak.currentMemberships.length > 0
  ) {
    return dataMembershipSkyTrak.currentMemberships.filter(
      (item) =>
        new Date(convertTimeUTCToLocal(item.expireDate)) > new Date() &&
        ((['simulation'].includes(item.source) &&
          (item.sku?.match(SKU_COURSEPLAY) ||
            item.sku?.match(SKU_FS_COURSEPLAY))) ||
          ['add-ons'].includes(item.source)) &&
        !['Upgraded', 'Refund'].includes(item.state) &&
        item.id !== idMembershipRenewed &&
        item.id !== idMembershipUpgraded
    );
  }
  return [];
};

export const filterSimulationFunc = (
  dataMembershipSkyTrak: MembershipSkyTrak | null,
  idMembershipRenewed: number,
  idMembershipUpgraded: number
) => {
  if (
    dataMembershipSkyTrak &&
    dataMembershipSkyTrak.currentMemberships &&
    dataMembershipSkyTrak.currentMemberships.length > 0
  ) {
    return dataMembershipSkyTrak.currentMemberships.filter(
      (item) =>
        new Date(convertTimeUTCToLocal(item.expireDate)) > new Date() &&
        ['simulation'].includes(item.source) &&
        !['Upgraded', 'Refund'].includes(item.state) &&
        !item.sku?.match(SKU_COURSEPLAY) &&
        !item.sku?.match(SKU_FS_COURSEPLAY) &&
        item.id !== idMembershipRenewed &&
        item.id !== idMembershipUpgraded
    );
  }
  return [];
};

export const checkDomainJP = () => {
  if (window.location.hostname.match(/skytrakgolf.jp/)) {
    return true;
  }
  return false;
};

export const returnExpireTime = (item: DataMembershipSkyTrak) => {
  if (item.frequencyUnit === 'month') {
    return item.frequencyCount * 30;
  }
  return item.frequencyCount;
  // if (item.frequencyUnit)
  //   if (item.sku.match(/CP-STD-30|Course Play 30 days|Game-Improvement-30/)) {
  //     return 30;
  //   }
  // if (item.sku.match(/CP-STD-60|Course Play 60 days|Game-Improvement-60/)) {
  //   return 60;
  // }
  // if (item.sku.match(/CP-STD-90|Course Play 90 days|Game-Improvement-90/)) {
  //   return 90;
  // }
  // if (item.sku.match(/CP-STD-180|Course Play 180 days|Game-Improvement-180/)) {
  //   return 180;
  // }
  // return 1;
};

export const returnExpireUnit = (item: DataMembershipSkyTrak) => {
  if (item.frequencyUnit !== 'year') {
    return 'NumberDay';
  }
  // if(  item.sku.match(
  //     /CP-STD-30|Course Play 30 days|CP-STD-60|Course Play 60 days|CP-STD-90|Course Play 90 days|CP-STD-180|Course Play 180 days|Game-Improvement-30|Game-Improvement-60|Game-Improvement-90|Game-Improvement-180/
  //   )
  // ) {
  //   return 'NumberDay';
  // }

  return 'NumberYear';
};

export const FeatureBuyMembership = ({
  mode,
  modeCurrent,
}: {
  mode: Mode;
  modeCurrent: Mode;
}) => {
  const intl = useIntl();
  const arrayOptionsPlan = useMemo(() => {
    let array = [
      'FeatureEssentialNew1',
      'FeatureEssentialNew2',
      'FeatureEssentialNew3',
    ];
    if (mode.lv > 0) {
      array = array.concat([
        'FeatureEssentialNew4',
        'FeatureEssentialNew5',
        'FeatureEssentialNew6',
      ]);
    }
    if (mode.lv > 1) {
      array.push('CoursePlayPractice');
    }
    if (mode.lv === 2) {
      array.push('CoursePlayForesightPack1');
    }
    if (mode.lv === 3) {
      array = array.concat([
        'CoursePlayTrackmanPack1',
        'FullPebbleBeachResortCoursePack',
      ]);
    }
    if (mode.lv > 3) {
      array = array.concat([
        'CoursePlayForesightPack1',
        'CoursePlayTrackmanPack1',
        'FullPebbleBeachResortCoursePack',
      ]);
    }
    return array;
  }, [mode]);

  const isJP = checkDomainJP();

  return (
    <VStack gap="8px" width="100%" alignItems="flex-start">
      {arrayOptionsPlan
        .map((title: string, idx: number) => ({ title, idx }))
        .filter(({ idx }) => !(isJP && [1, 2].includes(idx)))
        .map(({ title, idx }) => (
          <HStack key={idx} gap="4px" alignItems={'flex-start'} width={'100%'}>
            <Center
              minWidth={{ mobile: '24px' }}
              height={{ mobile: '24px' }}
              sx={{
                path: {
                  fill: modeCurrent.lv < mode.lv ? '#55BB2C' : '#54565B',
                },
              }}
            >
              <CheckMemberships />
            </Center>
            <HStack
              fontSize={14}
              lineHeight={{ mobile: '20px' }}
              letterSpacing={'0px'}
              color={modeCurrent.lv < mode.lv ? '#000' : '#54565B'}
              marginTop={'2px'}
              gap={'0px'}
              flexWrap={'wrap'}
            >
              <Box fontWeight={700} marginRight={idx > 6 ? '6px' : '0px'}>
                {intl.formatMessage({ id: title })}
              </Box>
              {title === 'CoursePlayForesightPack1' && (
                <Box>
                  {`(${intl.formatMessage({
                    id: 'NumberCoursesFoseightPackFeatures',
                  })})`}
                </Box>
              )}
              {title === 'CoursePlayTrackmanPack1' && (
                <Box>
                  {`(${intl.formatMessage({
                    id: 'NumberCoursesTrackmanPackFeatures',
                  })})`}
                </Box>
              )}
            </HStack>
          </HStack>
        ))}
    </VStack>
  );
};

export const FeatureShowMembershipBasic = () => {
  const intl = useIntl();
  const arrayOptionsPlan = [
    'FeatureEssentialNew1',
    'FeatureEssentialNew2',
    'FeatureEssentialNew3',
  ];

  return (
    <VStack gap="8px" width="100%" alignItems="flex-start">
      {arrayOptionsPlan
        .filter((_, idx) => !(checkDomainJP() && [1, 2].includes(idx)))
        .map((title: string, idx: number) => ({ title, idx }))
        .map(({ title, idx }) => (
          <HStack key={idx} gap="12px">
            <Center minWidth={{ mobile: '16px' }} height={{ mobile: '16px' }}>
              <Image src={IconCheckGreen} width={'16px'} />
            </Center>
            <Box
              fontWeight={600}
              fontSize={14}
              lineHeight={{ mobile: '20px' }}
              color={'#36383E'}
            >
              {intl.formatMessage({ id: title })}
            </Box>
          </HStack>
        ))}
    </VStack>
  );
};

export const FeatureShowMembershipTrial = () => {
  const intl = useIntl();
  const arrayOptionsPlan = [
    'FeatureEssentialNew1',
    'FeatureEssentialNew2',
    'FeatureEssentialNew3',
    'FeatureEssentialNew4',
    'FeatureEssentialNew5',
    'FeatureEssentialNew6',
    'CoursePlayPracticeTrial',
    'CoursePlayForesightPackTrial',
  ];

  return (
    <VStack gap="8px" width="100%" alignItems="flex-start">
      {arrayOptionsPlan
        .filter((_, idx) => !(checkDomainJP() && [1, 2].includes(idx)))
        .map((title: string, idx: number) => ({ title, idx }))
        .map(({ title, idx }) => (
          <HStack key={idx} gap="12px">
            <Center minWidth={{ mobile: '16px' }} height={{ mobile: '16px' }}>
              <Image src={IconCheckGreen} width={'16px'} />
            </Center>
            <Box
              fontWeight={600}
              fontSize={14}
              lineHeight={{ mobile: '20px' }}
              color={'#36383E'}
            >
              {intl.formatMessage({ id: title })}
            </Box>
          </HStack>
        ))}
    </VStack>
  );
};

export const FeatureShowMembership = ({ mode }: { mode: Mode }) => {
  const intl = useIntl();
  const arrayOptionsPlan = useMemo(() => {
    let array = [
      'FeatureEssentialNew1',
      'FeatureEssentialNew2',
      'FeatureEssentialNew3',
    ];
    if (mode.lv > 0) {
      array = array.concat([
        'FeatureEssentialNew4',
        'FeatureEssentialNew5',
        'FeatureEssentialNew6',
      ]);
    }
    if (mode.lv > 1) {
      array.push('CoursePlayPractice');
    }
    if (mode.lv === 2) {
      array.push('CoursePlayForesightPack1');
    }
    if (mode.lv === 3) {
      array = array.concat([
        'CoursePlayTrackmanPack1',
        'FullPebbleBeachResortCoursePack',
      ]);
    }
    if (mode.lv > 3) {
      array = array.concat([
        'CoursePlayForesightPack1',
        'CoursePlayTrackmanPack1',
        'FullPebbleBeachResortCoursePack',
      ]);
    }
    return array;
  }, [mode]);
  const isJP = checkDomainJP();
  return (
    <VStack gap="8px" width="100%" alignItems="flex-start">
      {arrayOptionsPlan
        .map((title: string, idx: number) => ({ title, idx }))
        .filter(({ idx }) => !(isJP && [1, 2].includes(idx)))
        .map(({ title, idx }) => (
          <HStack key={idx} gap="12px" alignItems={'flex-start'}>
            <Center minWidth={{ mobile: '16px' }} height={{ mobile: '20px' }}>
              <Image src={IconCheckGreen} width={'16px'} />
            </Center>
            <HStack
              fontSize={14}
              lineHeight={{ mobile: '20px' }}
              color={'#36383E'}
              gap={'0px'}
              flexWrap={'wrap'}
            >
              <Box fontWeight={700} marginRight={idx > 6 ? '6px' : '0px'}>
                {intl.formatMessage({ id: title })}
              </Box>
              {title === 'CoursePlayForesightPack1' && (
                <Box>
                  {`(${intl.formatMessage({
                    id: 'NumberCoursesFoseightPackFeatures',
                  })})`}
                </Box>
              )}
              {title === 'CoursePlayTrackmanPack1' && (
                <Box>
                  {`(${intl.formatMessage({
                    id: 'NumberCoursesTrackmanPackFeatures',
                  })})`}
                </Box>
              )}
            </HStack>
          </HStack>
        ))}
    </VStack>
  );
};

export const FeatureShowMembershipCoreTrackman = () => {
  const intl = useIntl();
  const arrayOptionsPlan = [
    'FeatureEssentialNew1',
    'FeatureEssentialNew2',
    'FeatureEssentialNew3',
    'FeatureEssentialNew4',
    'FeatureEssentialNew5',
    'FeatureEssentialNew6',
    'CoursePlayPractice',
    'CoursePlayTrackmanPack1',
    'FullPebbleBeachResortCoursePack',
  ];

  return (
    <VStack gap="8px" width="100%" alignItems="flex-start">
      {arrayOptionsPlan
        .filter((_, idx) => !(checkDomainJP() && [1, 2].includes(idx)))
        .map((title: string, idx: number) => (
          <HStack key={idx} gap="12px">
            <Center minWidth={{ mobile: '16px' }} height={{ mobile: '16px' }}>
              <Image src={IconCheckGreen} width={'16px'} />
            </Center>
            <HStack
              fontWeight={600}
              fontSize={14}
              lineHeight={{ mobile: '20px' }}
              color={'#36383E'}
              gap={'0px'}
              flexWrap={'wrap'}
            >
              <Box fontWeight={700} marginRight={'6px'}>
                {intl.formatMessage({ id: title })}
              </Box>
              {title === 'CoursePlayForesightPack1' && (
                <Box>
                  {`(${intl.formatMessage({
                    id: 'NumberCoursesFoseightPackFeatures',
                  })})`}
                </Box>
              )}
              {title === 'CoursePlayTrackmanPack1' && (
                <Box>
                  {`(${intl.formatMessage({
                    id: 'NumberCoursesTrackmanPackFeatures',
                  })})`}
                </Box>
              )}
            </HStack>
          </HStack>
        ))}
    </VStack>
  );
};

export const MembershipPerks = ({
  mode,
  modeCurrent,
}: {
  mode: Mode;
  modeCurrent: Mode;
}) => {
  const intl = useIntl();
  const arrayOptionsPlan = [
    'NumberNewCourseEveryMonth',
    'PebbleBeachCourseAccess',
    'PebbleBeachBethpageBlackCourseAccess',
    'ElitMembershipPerks1',
    'ElitMembershipPerks2',
    'OffGolftecSwingEvaluation',
  ];

  return (
    <VStack gap="8px" width="100%" alignItems="flex-start">
      {arrayOptionsPlan
        .filter((_, idx) => !(checkDomainJP() && [3, 4, 5].includes(idx)))
        .map(
          (title: string, idx: number) =>
            ((mode.lv === 1 && [5].includes(idx)) ||
              (mode.lv === 2 && [0, 1, 5].includes(idx)) ||
              (mode.lv === 3 && [0, 2, 5].includes(idx)) ||
              (mode.lv === 4 && [0, 1, 3, 4, 5].includes(idx))) && (
              <HStack key={idx} gap="4px" alignItems={'flex-start'}>
                <Center
                  minWidth={{ mobile: '24px' }}
                  height={{ mobile: '20px' }}
                  sx={{
                    path: {
                      fill: modeCurrent.lv < mode.lv ? '#55BB2C' : '#54565B',
                    },
                  }}
                >
                  <Perks />
                </Center>
                <Box
                  fontWeight={500}
                  fontStyle={'italic'}
                  fontSize={14}
                  lineHeight={{ mobile: '20px' }}
                  color={modeCurrent.lv < mode.lv ? '#000' : '#54565B'}
                >
                  {title === 'NumberNewCourseEveryMonth' ? (
                    intl.formatMessage(
                      { id: title },
                      { number: mode.lv === 4 ? 2 : 1 }
                    )
                  ) : title === 'OffGolftecSwingEvaluation' ? (
                    intl.formatMessage(
                      { id: title },
                      {
                        amount: mode.lv === 4 ? 100 : mode.lv >= 2 ? 75 : 25,
                      }
                    )
                  ) : title === 'ElitMembershipPerks1' ? (
                    <HStack spacing={'0px'} gap={'0px'} flexWrap={'wrap'}>
                      <Box marginRight={'6px'}>
                        {intl.formatMessage({ id: title })}
                      </Box>
                      <Box
                        fontSize={12}
                        lineHeight={'16px'}
                        color={'#54565B'}
                      >{`(${intl.formatMessage({
                        id: 'USCustomersOnly',
                      })})`}</Box>
                    </HStack>
                  ) : (
                    intl.formatMessage({ id: title })
                  )}
                </Box>
              </HStack>
            )
        )}
    </VStack>
  );
};

export const LegalDisclaimer = ({ priceItem }: { priceItem: number }) => {
  const intl = useIntl();

  return (
    <VStack
      gap={'0px'}
      alignItems={'flex-start'}
      width={'100%'}
      background={'#F4F5F6'}
      rounded={16}
      padding={'0px 8px'}
    >
      <HStack
        width={'100%'}
        gap={{ mobile: '16px' }}
        padding={'12px'}
        alignItems={'flex-start'}
      >
        <Center width={'24px'} minWidth={'24px'}>
          <CreditCardCheck />
        </Center>
        <Box
          fontSize={13}
          lineHeight={'18px'}
          fontWeight={500}
          color={'#54565B'}
          fontStyle={'italic'}
        >
          {intl.formatMessage(
            { id: 'LegalDisclaimer1' },
            {
              amount: intl
                .formatNumber(priceItem, {
                  style: 'currency',
                  currency: 'USD',
                  minimumFractionDigits: minimumFractionDigits(priceItem),
                })
                .replace('US', ''),
              strong: (chunk: ReactNode) => (
                <Box
                  as={'span'}
                  fontWeight={800}
                  fontStyle={'italic'}
                  fontSize={15}
                >
                  {chunk}
                </Box>
              ),
            }
          )}
        </Box>
      </HStack>
      <HStack
        gap={{ mobile: '16px' }}
        background={'#FFF'}
        rounded={12}
        padding={'12px'}
        marginBottom={'8px'}
        alignItems={'flex-start'}
      >
        <Center
          width={'24px'}
          minWidth={'24px'}
          sx={{
            path: { fill: '#54565B' },
          }}
        >
          <Info />
        </Center>
        <Box
          fontSize={11}
          lineHeight={'16px'}
          fontWeight={400}
          color={'#54565B'}
          fontStyle={'italic'}
          letterSpacing={'0.2px'}
        >
          <Box>
            {intl.formatMessage(
              { id: 'LegalDisclaimer2' },
              {
                a: (chunk: ReactNode) => (
                  <Link
                    fontWeight={500}
                    href={
                      checkDomainJP()
                        ? intl.formatMessage({ id: 'SupportSkytrakGolfJP' })
                        : intl.formatMessage({ id: 'SupportSkytrakGolf' })
                    }
                    textDecoration={'underline'}
                    _hover={{
                      color: '#55BB2C',
                    }}
                    target="_blank"
                  >
                    {chunk}
                  </Link>
                ),
              }
            )}
          </Box>
          <Box marginTop={'8px'}>
            {intl.formatMessage({ id: 'LegalDisclaimer3' })}
          </Box>
        </Box>
      </HStack>
    </VStack>
  );
};

export const convertTimeUTCToLocal = (timeUTC: Date): string => {
  const safeExpireDate = timeUTC.toString().endsWith('Z')
    ? timeUTC.toString()
    : timeUTC.toString() + 'Z';

  return safeExpireDate;
};

export const getPrivacyOrTermsLink = (
  type: string,
  domain: string,
  configurationPublic: ConfigurationPublicData | null,
  golftecPrivacyClubhouse?: string,
  golftecTermsClubhouse?: string
): string => {
  if (type === 'privacy') {
    if (checkDomainJP()) {
      return (
        configurationPublic?.skytrakJapanPrivacyPolicy ??
        'https://golftec.golfdigest.co.jp/policy/'
      );
    } else if (domain === 'skytrak') {
      return (
        configurationPublic?.skytrakPrivacyPolicy ??
        golftecPrivacyClubhouse ??
        ''
      );
    }
    return golftecPrivacyClubhouse ?? '';
  }

  // type === 'terms'
  if (checkDomainJP()) {
    return (
      configurationPublic?.skytrakJapanTerms ??
      'https://golftec.golfdigest.co.jp/riyokiyaku/'
    );
  } else if (domain === 'skytrak') {
    return (
      configurationPublic?.skytrakTerms ??
      'https://policies.golftec.com/us-canada/terms-of-use/'
    );
  }
  return golftecTermsClubhouse ?? '';
};

export const currentPriceProduct = (product: ProductInterface | undefined) => {
  const timeZone = 'America/Los_Angeles';
  const dateNowAmerica = new Date(
    new Date().toLocaleString('en-US', { timeZone: timeZone })
  ).getTime();
  let specialFromDate = product?.special_from_date
    ? new Date(product?.special_from_date).getTime()
    : null;
  let specialToDate = product?.special_to_date
    ? new Date(product?.special_to_date).getTime()
    : null;
  if (specialToDate) {
    specialToDate += 86400 * 1000;
  }

  let finalPrice = product?.price?.regularPrice?.amount?.value ?? 0;
  let regularPrice = product?.price?.regularPrice?.amount?.value ?? 0;

  if (product?.special_price) {
    if (specialFromDate && specialToDate) {
      if (
        dateNowAmerica >= specialFromDate &&
        dateNowAmerica <= specialToDate
      ) {
        finalPrice = product.special_price;
      }
    } else if (!specialFromDate && specialToDate) {
      if (dateNowAmerica <= specialToDate) {
        finalPrice = product.special_price;
      }
    } else if (specialFromDate && !specialToDate) {
      if (dateNowAmerica >= specialFromDate) {
        finalPrice = product.special_price;
      }
    }
    finalPrice = product?.special_price;
  }

  return finalPrice < regularPrice ? finalPrice : regularPrice;
};

export const returnNameLaunchMonitor = (deviceCode: string) => {
  return deviceCode
    ? `${deviceCode.replace(/\s+/g, '')}LaunchMonitor`
    : 'SKYTRAKLaunchMonitor';

  // return 'SKYTRAKLaunchMonitor';
};

export const returnNameRedeem = (deviceCode: string) => {
  return deviceCode
    ? `${deviceCode.replace(/\s+/g, '')}Redeem`
    : 'SKYTRAKRedeem';

  // return 'SKYTRAKPLUSRedeem';
};

export const returnNameLaunchMonitorImage = (deviceCode: string) => {
  return deviceCode === 'FORESIGHT'
    ? MyDeviceFS
    : deviceCode === 'SKYTRAK PLUS'
    ? MyDeviceSTPlus
    : deviceCode === 'SKYTRAK MAX'
    ? MyDeviceSTMax
    : MyDeviceST;
};

export const FeatureExtendedWarranty = () => {
  const intl = useIntl();
  const arrayOptionsPlan = [
    'ExtendedWarranty1',
    'ExtendedWarranty2',
    'ExtendedWarranty3',
    'ExtendedWarranty4',
    'ExtendedWarranty5',
  ];

  return (
    <VStack gap="8px" width="100%" alignItems="flex-start">
      {arrayOptionsPlan
        .map((title: string, idx: number) => ({ title, idx }))
        .map(({ title, idx }) => (
          <HStack key={idx} gap="12px" alignItems={'flex-start'}>
            <Center minWidth={{ mobile: '16px' }} height={{ mobile: '20px' }}>
              <Image src={IconCheckGreen} width={'16px'} />
            </Center>
            <HStack
              fontSize={14}
              lineHeight={{ mobile: '20px' }}
              color={'#36383E'}
              gap={'0px'}
              flexWrap={'wrap'}
            >
              <Box fontWeight={700} marginRight={'6px'}>
                {intl.formatMessage({ id: title })}
              </Box>
            </HStack>
          </HStack>
        ))}
    </VStack>
  );
};

export const FeatureExtendedWarrantyNotIncluded = () => {
  const intl = useIntl();
  const arrayOptionsPlan = [
    'ExtendedWarrantyNotIncluded1',
    'ExtendedWarrantyNotIncluded2',
    'ExtendedWarrantyNotIncluded3',
  ];

  return (
    <VStack gap="8px" width="100%" alignItems="flex-start">
      {arrayOptionsPlan
        .map((title: string, idx: number) => ({ title, idx }))
        .map(({ title, idx }) => (
          <HStack key={idx} gap="12px" alignItems={'flex-start'}>
            <Center minWidth={{ mobile: '16px' }} height={{ mobile: '20px' }}>
              <Image src={IconNotIncluded} width={'16px'} />
            </Center>
            <HStack
              fontSize={14}
              lineHeight={{ mobile: '20px' }}
              color={'#36383E'}
              gap={'0px'}
              flexWrap={'wrap'}
            >
              <Box fontWeight={700} marginRight={'6px'}>
                {intl.formatMessage({ id: title })}
              </Box>
            </HStack>
          </HStack>
        ))}
    </VStack>
  );
};

export const customRound = (price, precision: number) => {
  let multiplicator = Math.pow(10, precision);
  price = parseFloat((price * multiplicator).toFixed(Math.min(precision, 20)));
  return parseFloat(
    (Math.round(price) / multiplicator).toFixed(Math.min(precision, 20))
  );
};

export const checkUSCustomer = (userData: UserData) => {
  if (
    userData &&
    userData.playerLocation &&
    userData.playerLocation.countryCode &&
    userData.playerLocation.countryCode === 'US' &&
    (userData.country === 'United States' ||
      userData.country === '' ||
      _.isNil(userData.country))
  ) {
    return true;
  }
  return false;
};

export const colorClubFunc = (swingTypeName: string) => {
  switch (swingTypeName) {
    case 'Pitch':
      return '#CC52B4';
    case '1/2':
      return '#B9F961';
    case '3/4':
      return '#59B6F7';
    case 'Full':
      return '#EFE759';
    default:
      return '#4BDCE5';
  }
};

export function feetDecimalToFeetInches(value) {
  const feet = Math.floor(value);
  const inches = Math.round((value - feet) * 12);
  return `${feet}'${inches}''`;
}

export function deepDecode(input) {
  let s = input;

  if (typeof s !== 'string') return s;

  for (let iter = 0; iter < 10; iter++) {
    const prev = s;

    const t = s.trim();
    if (t.length >= 2 && t[0] === '"' && t[t.length - 1] === '"') {
      try {
        s = JSON.parse(t);
        continue;
      } catch (e) {}
    }

    if (/%[0-9A-Fa-f]{2}/.test(s)) {
      try {
        const dec = decodeURIComponent(s);
        if (dec !== s) {
          s = dec;
          continue;
        }
      } catch (e) {}
    }

    if (s.includes('\\\\') || s.includes('\\"') || s.includes("\\'")) {
      const un = s
        .replace(/\\\\/g, '\\')
        .replace(/\\"/g, '"')
        .replace(/\\'/g, "'");
      if (un !== s) {
        s = un;
        continue;
      }
    }

    if (s === prev) break;
  }

  if (typeof s === 'string') {
    const u = s.trim();
    if (
      (u[0] === '{' && u[u.length - 1] === '}') ||
      (u[0] === '[' && u[u.length - 1] === ']')
    ) {
      try {
        return JSON.parse(u);
      } catch (e) {}
    }
  }

  return s;
}
